import React, { useState } from 'react'
import { strCol, dateTimeCol } from '@integec/grid-tools/lib/cols'
import { getApiTargetInfo, isValidYearRange } from 'core'
import { connect } from 'react-redux'
import { pjmGadsAcctManager } from 'api/pgads.js'
import CommonScreen from './CommonScreen'
import { DatePicker } from 'antd'
import moment from 'moment'

const PjmGadsAcctManager = () => {
  const [selectedDateRangePicker, setSelectedDateRagePicker] = useState([
    moment()
      .subtract(1, 'month')
      .startOf('month'),
    moment(),
  ])

  const screenCriteria = (s, p, u, onChange) => {
    return (
      <DatePicker.RangePicker
        style={{ marginLeft: '15px' }}
        allowClear={false}
        format="MM/DD/YYYY"
        value={selectedDateRangePicker}
        onChange={d => {
          setSelectedDateRagePicker(d)
          onChange()
          // retrieve({ dates: d })
        }}
      />
    )
  }
  const beforeRetrieveValidation = ({ validYearRange }) => {
    return isValidYearRange(
      validYearRange,
      selectedDateRangePicker[0],
      selectedDateRangePicker[1]
    )
  }
  const withCriteria = () => ({
    startDate: selectedDateRangePicker[0],
    endDate: selectedDateRangePicker[1],
  })
  return (
    <CommonScreen
      withCriteria={withCriteria}
      beforeRetrieveValidation={beforeRetrieveValidation}
      screenCriteria={screenCriteria}
      title="Account Manager Users"
      header={Headers}
      retrieveTask={pjmGadsAcctManager}
      autoRetrieve
      sortOptions={SortHeaders}
      altBy={d => d.processed}
      withoutModify
      withDelete={false}
      allowInsert={false}
    />
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
})

const Headers = [
  dateTimeCol({
    ident: 'effectivedate',
    display: 'Effective Date',
    width: 150,
  }),
  strCol({
    ident: 'userid',
    display: 'User Id',
    width: 250,
    isFiltered: true,
  }),
  strCol({
    ident: 'userAccess',
    display: 'User Access',
    width: 300,
    isFiltered: true,
  }),
  strCol({
    ident: 'activeYN',
    display: 'Active',
    isFiltered: true,
  }),
  strCol({
    ident: 'processed',
    display: 'Processed',
    isFiltered: true,
  }),
  strCol({
    ident: 'modifier',
    display: 'Modifier',
    width: 150,
  }),
  dateTimeCol({
    ident: 'modifieddate',
    display: 'Modified Date',
    width: 150,
  }),
]

const SortHeaders = [
  dateTimeCol({
    ident: 'modifieddate',
    display: 'Modified Date',
    width: 150,
    sortOrder: 'desc',
  }),
  strCol({
    ident: 'processed',
    display: 'Processed',
    sortOrder: 'desc',
  }),
  strCol({
    ident: 'userid',
    display: 'User Id',
    width: 200,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'userAccess',
    display: 'User Access',
    width: 250,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'activeYN',
    display: 'Active',
    sortOrder: 'desc',
  }),
  dateTimeCol({
    ident: 'effectivedate',
    display: 'Effective Date',
    width: 150,
    sortOrder: 'desc',
  }),
  // strCol({
  //   ident: 'modifier',
  //   display: 'Modifier',
  //   width: 150,
  //   sortOrder: 'dec',
  // }),
]

export default connect(mapStateToProps)(PjmGadsAcctManager)
